import React from "react";
import T from "prop-types";
import { RadioGroupField } from "MODULES/shared/components/Forms";
import { Field } from "redux-form";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import { BUYING_STORE_ID } from "MODULES/PurchaseOrders/constants";

const LocationRadioField = ({
  currentUser,
  disabled = false,
  label = "Buying Store",
  name = BUYING_STORE_ID,
  required = true
}) => (
  <Field
    disabled={disabled}
    name={name}
    label={label}
    component={RadioGroupField}
    options={currentUser.locations.map(l => ({
      value: l.id,
      text: l.name
    }))}
    required={required}
  />
);

LocationRadioField.propTypes = {
  currentUser: T.shape({}),
  disabled: T.bool,
  label: T.string,
  name: T.string,
  required: T.bool
};

export default withCurrentUser(LocationRadioField);



// WEBPACK FOOTER //
// ./app/modules/Locations/components/BuyingStoreRadioField.jsx